// crypto-polyfill.ts
// Polyfill más robusto para crypto.getRandomValues

if (typeof window !== 'undefined') {
  // Si crypto existe pero getRandomValues no, o si no funciona correctamente
  if (!window.crypto || typeof window.crypto.getRandomValues !== 'function') {
    const cryptoPolyfill = {
      getRandomValues: function <T extends ArrayBufferView | null>(array: T): T {
        if (!array) return array
        
        const bytes = new Uint8Array(array.buffer, array.byteOffset, array.byteLength)
        for (let i = 0; i < bytes.length; i++) {
          bytes[i] = Math.floor(Math.random() * 256)
        }
        return array
      },
      randomUUID: function (): string {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
          const r = Math.random() * 16 | 0
          const v = c === 'x' ? r : (r & 0x3 | 0x8)
          return v.toString(16)
        })
      }
    }

    if (!window.crypto) {
      // @ts-ignore
      window.crypto = cryptoPolyfill
    } else {
      // Si crypto existe pero getRandomValues no funciona, lo reemplazamos
      window.crypto.getRandomValues = cryptoPolyfill.getRandomValues
      if (!window.crypto.randomUUID) {
        // @ts-ignore
        window.crypto.randomUUID = cryptoPolyfill.randomUUID
      }
    }
  }

  // Agregar también al contexto global por si acaso
  if (typeof global !== 'undefined' && !global.crypto) {
    // @ts-ignore
    global.crypto = window.crypto
  }
}

export {}